import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ProfileRepository from '../../repositories/ProfileRepository';
import ProfileDataRepository from '../../../data/repositories/ProfileDataRepository';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_PERIODS_REQUEST });
    // leer perfil
    const profileRepository: ProfileRepository = new ProfileDataRepository();
    const periodsResponse = yield call(profileRepository.getPeriods);
    if (!periodsResponse) {
      throw new Error('error');
    }
    yield put({
      type: Types.GET_PERIODS_SUCCESS,
      data: periodsResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_PERIODS_FAILURE,
      error: 'Ocurrió un error al momento de leer los periodos del estudiante.'
    });
  }
}
